import PageHero from "@/components/PageHero"
import { useScrollReveal } from "@/hooks/useScrollReveal"
import {BookOpen, Bot, Video, Smartphone, Users, Award, CheckCircle, ArrowRight, Zap} from 'lucide-react'

const recursos = [
  { icon: BookOpen, title: "EW Academy", text: "Mais de 400 horas de aulas gravadas, organizadas por nível, do básico ao avançado.", color: "#0E8EA0" },
  { icon: Bot, title: "Lucy IA", text: "Tutora virtual inteligente disponível 24h via WhatsApp para tirar dúvidas e praticar conversação.", color: "#B038B2" },
  { icon: Video, title: "EW Live", text: "Aulas ao vivo semanais com professores para prática de conversação e interação real.", color: "#F5C542" },
  { icon: Smartphone, title: "Apps iOS e Android", text: "Estude de qualquer lugar com nossos aplicativos nativos para celular e tablet.", color: "#6CC4C4" },
  { icon: Users, title: "Comunidade", text: "Comunidade exclusiva com gamificação, desafios e interação entre alunos.", color: "#B038B2" },
  { icon: Award, title: "Certificados", text: "Certificados de conclusão em cada nível para comprovar sua evolução.", color: "#0E8EA0" },
]

const vantagens = [
  "Acesso completo a todos os recursos por uma assinatura",
  "Estude no seu ritmo, sem horários fixos",
  "Suporte 24h com inteligência artificial",
  "Aulas ao vivo semanais inclusas",
  "Conteúdo atualizado constantemente",
  "Certificados reconhecidos em cada nível",
  "Comunidade ativa de alunos",
  "Aplicativos para estudar offline",
]

export default function EWPass() {
  const section1 = useScrollReveal()
  const section2 = useScrollReveal()
  const section3 = useScrollReveal()

  return (
    <>
      <PageHero
        title="EW Pass — Plano de Assinatura"
        subtitle="A plataforma completa de inglês da English Work. Tudo o que você precisa em um único plano."
      />

      {/* Recursos */}
      <section className="py-20 bg-white">
        <div
          ref={section1.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-4" style={{ color: "#0E8EA0" }}>
            O que está incluso no EW Pass
          </h2>
          <p className="text-center text-gray-600 max-w-2xl mx-auto mb-12">
            Uma plataforma digital que reúne tudo o que o aluno precisa para aprender inglês de forma estruturada, prática e contínua.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {recursos.map((item) => (
              <div
                key={item.title}
                className="rounded-2xl p-7 border border-gray-100 hover:shadow-lg transition-all duration-300 group"
              >
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform"
                  style={{ backgroundColor: `${item.color}15` }}
                >
                  <item.icon size={26} style={{ color: item.color }} />
                </div>
                <h3 className="text-lg font-bold mb-2 text-gray-900">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Vantagens */}
      <section className="py-20" style={{ backgroundColor: "#F8F9FA" }}>
        <div
          ref={section2.ref}
          className={`max-w-4xl mx-auto px-5 transition-all duration-700 ${section2.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10" style={{ color: "#0E8EA0" }}>
            Vantagens do EW Pass
          </h2>
          <div className="grid md:grid-cols-2 gap-4">
            {vantagens.map((item) => (
              <div key={item} className="flex items-start gap-3 p-4 bg-white rounded-xl border border-gray-100">
                <CheckCircle size={20} className="shrink-0 mt-0.5" style={{ color: "#0E8EA0" }} />
                <span className="text-gray-700 text-sm">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16" style={{ backgroundColor: "#0E8EA0" }}>
        <div
          ref={section3.ref}
          className={`max-w-3xl mx-auto px-5 text-center transition-all duration-700 ${section3.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <Zap size={40} className="text-white mx-auto mb-4" />
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">Comece sua jornada no inglês</h2>
          <p className="text-white/80 mb-8 max-w-xl mx-auto">
            Assine o EW Pass e tenha acesso completo a todas as ferramentas que você precisa para aprender inglês de verdade.
          </p>
          <a
            href="#"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white font-bold rounded-full text-sm transition-all duration-300 hover:scale-105 hover:shadow-lg"
            style={{ color: "#0E8EA0" }}
          >
            Assinar o EW Pass <ArrowRight size={16} />
          </a>
        </div>
      </section>
    </>
  )
}
